<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .overlay {
    width: 40rem;
    min-width: 40%;
    height: 100%;
    overflow: auto;

    &.outreach {
      background-image: url("/assets/img/marketing/masks/outreach.svg");
    }
    &.calls {
      background-image: url("/assets/img/marketing/masks/conversations.svg");
    }
    &.search {
      background-image: url("/assets/img/marketing/masks/aiSearch.svg");
    }

    &.projects {
      background-image: url("/assets/img/marketing/masks/projects.svg");
    }

    background-size: cover;

    display: flex;
    flex-direction: column;
    justify-content: center;
  }
</style>

<script>
  // @ts-check
  import { onMount } from "svelte";
  import { fly } from "svelte/transition";
  import { getMarketingPageContext } from "./context.svelte";
  import Calls from "./Slides/Calls.svelte";
  import Campaigns from "./Slides/Campaigns.svelte";
  import Dashboard from "./Slides/Dashboard.svelte";
  import Outbox from "./Slides/Outbox.svelte";
  import Projects from "./Slides/Projects.svelte";
  import Reports from "./Slides/Reports.svelte";
  import Search from "./Slides/Search.svelte";
  import Todo from "./Slides/Todo.svelte";

  const ctx = getMarketingPageContext();

  const maskMap = {
    "/search": "search",
    "/search-results": "search",
    "/calls": "calls",
    "/call": "calls",
    "/projects": "projects",
  };
  let cls = $derived(maskMap[ctx.page] || "outreach");
  let display = $state(false);
  onMount(() => {
    display = true;
  });

  const componentMap = {
    "/call": Calls,
    "/calls": Calls,
    "/campaign": Campaigns,
    "/campaigns": Campaigns,
    "/dashboard": Dashboard,
    "/outbox": Outbox,
    "/projects": Projects,
    "/reports": Reports,
    "/search": Search,
    "/search-results": Search,
    "/todo": Todo,
  };

  let page = $derived(componentMap[ctx.page]);
</script>

{#if display}
  <div class="overlay {cls}" transition:fly={{ x: 1000, duration: 1000 }}>
    {@render page?.()}
  </div>
{/if}
